// @flow
import React from 'react';

import './style.pcss';

type Props = {
  label: Object,
  locale: string
}

const AffiliateBanner = ({ label, locale }: Props) => (
  <div className='ui-site-affiliate-banner'>
    <div className='ui-site-affiliate-banner__border' />
    <div className='ui-site-affiliate-banner__title'>
      <i className='ui-site-affiliate-banner__title-icon material-icons'>thumb_up</i>
      <span>
        {label[locale]}
      </span>
    </div>
  </div>
);
export default AffiliateBanner;
